/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Price_Auction_PrincipalInputs */

const cs_sreality_attr_price_auction_principal = /** @type {(inputs: Sreality_Attr_Price_Auction_PrincipalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyvolávací cena`)
};

const en_sreality_attr_price_auction_principal = /** @type {(inputs: Sreality_Attr_Price_Auction_PrincipalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening bid`)
};

/**
* | output |
* | --- |
* | "Opening bid" |
*
* @param {Sreality_Attr_Price_Auction_PrincipalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_price_auction_principal = /** @type {((inputs?: Sreality_Attr_Price_Auction_PrincipalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Price_Auction_PrincipalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_price_auction_principal(inputs)
	return cs_sreality_attr_price_auction_principal(inputs)
});